
export const AlignCenterHorizontal = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.375 18V6H12.625V18H11.375Z" fill={color}/>
      <path d="M7 10.8V9H17V10.8H7Z" fill={color}/>
      <path d="M8.875 15V13.2H15.125V15H8.875Z" fill={color}/>
    </svg>
  );
}